import { useMutation, useQuery } from "@tanstack/react-query";
import { apiClient } from "./api-client";

export function useAttachPaymentMethods() {
  return useMutation({
    mutationFn: ({ bookingSlug }) =>
      apiClient({
        url: "users/attach-payment-methods",
        method: "POST",
        params: { bookingSlug }
      })
  });
}

export function usePaymentMethodsQuery(options = {}) {
  return useQuery({
    queryKey: ["users", "payment-methods"],
    queryFn: () =>
      apiClient({
        url: "users/payment-methods",
        method: "GET"
      }),
    ...options
  });
}

export function useUpdateBookingPaymentType() {
  return useMutation({
    mutationFn: ({ bookingSlug, paymentType }) => {
      const formData = new FormData();
      formData.append("paymentType", paymentType);
      return apiClient({
        url: `booking/update/${bookingSlug}`,
        method: "PATCH",
        data: formData
      });
    }
  });
}

export function useDetachPaymentMethod() {
  return useMutation({
    mutationFn: (pmId) =>
      apiClient({
        url: "users/detach-payment-methods",
        method: "POST",
        data: { pmId }
      })
  });
}

export function useSetPrimaryPaymentMethod() {
  return useMutation({
    mutationFn: (pmId) =>
      apiClient({
        url: "users/payment-methods/default",
        method: "PATCH",
        data: { pmId }
      })
  });
}
